import { render, staticRenderFns } from "./Gazettes.vue?vue&type=template&id=83025f2a&scoped=true"
import script from "./Gazettes.vue?vue&type=script&lang=js"
export * from "./Gazettes.vue?vue&type=script&lang=js"
import style0 from "./Gazettes.vue?vue&type=style&index=0&id=83025f2a&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83025f2a",
  null
  
)

export default component.exports